import {type FirebaseApp, initializeApp} from "@firebase/app"
import {applyActionCode, getAuth, verifyPasswordResetCode, confirmPasswordReset} from "@firebase/auth";
import {Auth} from "./firebase/auth";
import {NotificationsController} from "../utils/notifications";

export class AccionesUsuarioController {

    /* INSTANCE */
    public static instance: AccionesUsuarioController;

    private readonly firebaseApp: FirebaseApp;
    private auth: Auth;

    public static async build(): Promise<void> {
        AccionesUsuarioController.instance = new this();
    }

    public constructor() {
        this.auth = Auth.get() as Auth;
        this.firebaseApp = initializeApp(require("./firebase/firebase.json"));
        const auth = getAuth(this.firebaseApp);
        const url = new URL(window.location.href);
        const mode = url.searchParams.get("mode");
        const oobCode = url.searchParams.get("oobCode");
        const email = url.searchParams.get("email");
        if (mode && oobCode) {
            if (mode === "resetPassword") {
                const popup = document.getElementById("action-password-reset") as HTMLElement;
                const info = popup.getElementsByClassName("pregunta1")[0] as HTMLElement;
                info.textContent = info.textContent + " " + email;
                const button = document.getElementById("resetPassword") as HTMLButtonElement;
                const newPassword = document.getElementById("newPassword") as HTMLInputElement;
                verifyPasswordResetCode(auth, oobCode).then(() => {
                    button.addEventListener("click", this.confirmPassword.bind(this, auth, oobCode, newPassword));
                }).catch((error) => {
                    this.showErrors(error);
                });
            }
            if (mode === "verifyEmail" && email) {
                applyActionCode(auth, oobCode).then(async () => {
                    await this.auth.update({email: email, enabled: true});
                    window.location.href = "/usuario/?section=mi-perfil";
                }).catch((error) => {
                    this.showErrors(error);
                });
            }
        }
    }

    private showErrors(error: any) : void {
        if (error.code === 'auth/invalid-action-code') NotificationsController.build("error", "El código de validación es incorrecto.");
        if (error.code === 'auth/expired-action-code') NotificationsController.build("error", "El código de validación ha expirado.");
        if (error.code === 'auth/user-disabled') NotificationsController.build("error", "El código de validación no puede ser utilizado en la dirección de email proporcionada.");
        if (error.code === 'auth/user-not-found') NotificationsController.build("error", "La cuenta de usuario que se está intentando validar no existe.");
        if (error.code === 'auth/weak-password') NotificationsController.build("error", "La contraseña es muy débil.");
    }

    private confirmPassword(auth: any, oobCode: string, newPassword: HTMLInputElement): void {
        confirmPasswordReset(auth, oobCode, newPassword.value).then(() => {
            document.getElementById("resetPassword")!.style.display = "none";
            document.getElementById("newPassword")!.style.display = "none";
            NotificationsController.build("info", "La contraseña se ha restablecido correctamente");
        }).catch((error) => {
            this.showErrors(error);
        });
    }

}
